/**
 * Headers for every pop.in GraphQL call the portal makes. Dependency-free so the
 * staff-door rule below is unit-testable without a Firebase session.
 */

/** Who is asking, as far as the request headers care. */
export interface RequestViewer {
  /** The signed-in user holds `super_admin` (from `self.globalRoles`). */
  isSuperAdmin: boolean;
}

/**
 * Build the request headers. `X-Act-As-Admin: true` is the staff door: the
 * backend drops the platform admin claim from an interactive (Firebase) login
 * unless the request asks for it (`reloaded-rest/src/graphql.ts`), the same
 * header the admin GUI always sends. The portal sends it ONLY for a super admin
 * and only on the calls that opt in by passing a viewer — never for a partner.
 * Alternative the backend owner may prefer: a super_admin fallback on the admin-only reads, as admin_allBrands has; then this header goes away.
 */
export function requestHeaders(token: string, viewer?: RequestViewer): Record<string, string> {
  const headers: Record<string, string> = {
    'content-type': 'application/json',
    authorization: token,
    // Identifies the calling pop.in client app, matching the public GraphQL
    // contract the admin-gui uses.
    'X-App-Id': 'mighty',
  };
  if (viewer?.isSuperAdmin === true) headers['X-Act-As-Admin'] = 'true';
  return headers;
}
